import React from "react";
import "./styles.scss";
import completedIcom from "../../assets/icons/completed.png"
import closeIcon from "../../assets/icons/x-circle.svg"
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

type Tprop = {
    status: string
    show: boolean
    setShow: (open: boolean) => void
    errorMessage?: string
}

export const EmailVerifyDialogBox: React.FC<Tprop> = ({ status, show, setShow, errorMessage }) => {

    const navigate = useNavigate()

    const close = () => {
        setShow(false);
        navigate("/login")
    }

    const heading = "...Almost...There!"
    const message1 = errorMessage || "Hero name,Phone or Email ID already exists for another user.Kindely enter unique hero name,Mobile Number and Mail id to proceed."
    const link1 = "Click Here To login"
    const link2 = "Account Page"

    return (
        <div className="emailverify-dialogbox">
            <div className="box">
                <div className="close">
                    <div className="dialog-btn-close" onClick={() => close()}>
                        <img src={closeIcon} alt="not-found" />
                    </div>
                </div>
                {status === "waiting" ? <p className="dialog-heading">{heading}</p> : status === "success" && <img className="dialog-heading-icon" src={completedIcom} alt={"not found"} />}
                <p className="text">{message1}
                    {status === "success" ? <Link to="/account" className="dialog-link">{link2}</Link>
                        : status === "waiting" ? <Link to="/login"><p className="dialog-link" >{link1}</p></Link> : ""}</p>
                {status === "error" && <div className="dialog-btn" onClick={() => close()}>OK</div>}
            </div>
        </div>
    );
};